import axios from "axios";
import { DataGrid, DropDownBox } from "devextreme-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Column,
  FilterRow,
  HeaderFilter,
  Scrolling,
  Selection,
} from "devextreme-react/data-grid";

export default function ProjectDropDownBox(props) {
  const { type, projectDropDownBoxRef, data, updateBasicInfo } = props;

  // console.debug("[ProjectDropDownBox]");

  //   const payment = useSelector((state) => state.payment);

  const [projectDataSource, setProjectDataSource] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([data.contrNo]);
  const [isDropDownOpened, setDropDownOpened] = useState(false);

  const userInfo = useSelector((state) => state.userInfo);

  const dispatch = useDispatch();

  useEffect(async () => {
    async function fetchData() {
      let result = null;

      if (type == "payment") {
        result = await axios.get(
          `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/contrNo`
        );
      } else if (type == "sales") {
        result = await axios.get(
          `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/contrNo?employeeNo=${userInfo.employeeNo}&div=${userInfo.div}`
        );
      }

      setProjectDataSource(result.data);
    }

    fetchData();
  }, []);

  useEffect(() => {
    setSelectedRowKeys([data.contrNo]);
  }, [data.contrNo]);

  const onOptionChanged = (e) => {
    if (e.name === "opened") {
      setDropDownOpened(e.value);
    }
  };

  const contentRender = () => {
    const onSelectionChanged = (args) => {
      setSelectedRowKeys(args.selectedRowKeys);

      if (args.selectedRowsData.length > 0) {
        setDropDownOpened(false);

        dispatch(
          updateBasicInfo({
            contrNo: args.selectedRowKeys[0],
            sprName: args.selectedRowsData[0].sprName,
            quotNo: args.selectedRowsData[0].quotNo,
          })
        );

        if (projectDropDownBoxRef.current) {
          projectDropDownBoxRef.current.instance.option(
            "validationStatus",
            "valid"
          );
        }
      }
    };

    return (
      <DataGrid
        keyExpr={"contrNo"}
        dataSource={projectDataSource}
        remoteOperations={true}
        height={250}
        // height={700}
        selectedRowKeys={selectedRowKeys}
        hoverStateEnabled={true}
        focusedRowEnabled={true}
        defaultFocusedRowKey={selectedRowKeys[0]}
        onSelectionChanged={onSelectionChanged}
      >
        <Scrolling mode={"virtual"} showScrollbar={"always"} />
        <Selection mode={"single"} />
        <HeaderFilter visible={true} />
        <FilterRow visible={true} applyFilter={"auto"} />

        <Column dataField={"contrNo"} caption={"Contract No."} width={150} />
        <Column dataField={"sprName"} caption={"Sponsor"} />
        <Column dataField={"projName"} caption={"Project"} />
      </DataGrid>
    );
  };

  return (
    <DropDownBox
      ref={projectDropDownBoxRef}
      opened={isDropDownOpened}
      dropDownOptions={{
        width: 700,
        // , height: 700
      }}
      dataSource={projectDataSource}
      value={selectedRowKeys[0]}
      displayExpr={"contrNo"}
      valueExpr={"contrNo"}
      contentRender={contentRender}
      readOnly={data.action != "insert" ? true : false}
      onOptionChanged={onOptionChanged}
    />
  );
}
